import React, {HTMLProps} from 'react';
import cn from 'classnames';
import {Seconds} from '@store/@types/util';
import './CallTick.sass';

interface CallTickProps extends HTMLProps<HTMLDivElement> {
  duration: Seconds;
  location: number;
  type: 'comment' | 'player' | 'player-dotted';
  className?: string;
  setRef?: (ref: HTMLDivElement | null) => void;
}

export const CallTick: React.FC<CallTickProps> = ({
  className,
  duration,
  location,
  setRef,
  type,
  ...rest
}) => {
  const pctLocation = location / duration;

  return (
    <div
      role={type === 'comment' ? undefined : 'status'}
      {...rest}
      ref={r => setRef?.(r)}
      style={{left: pctLocation * 100 + '%'}}
      className={cn('call-tick', className, type)}
    />
  );
};
